import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10vh"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_TableComponent = _resolveComponent("TableComponent")!
  const _component_ListComponent = _resolveComponent("ListComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FormComponent),
    (_ctx.renderTable)
      ? (_openBlock(), _createBlock(_component_TableComponent, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.renderList)
      ? (_openBlock(), _createBlock(_component_ListComponent, {
          key: 1,
          "use-routes": true
        }))
      : _createCommentVNode("", true),
    _hoisted_2
  ]))
}